module.exports = __webpack_public_path__ + "assets/img/block-right-hover-c26f35b1.png";